import { i18n as SilentRenewI18N, SILENT_RENEW_PAGE_NS } from '../pages/SilentRenewPage/i18n';
import { i18n as WorkboardI18N, WORKBOARD_PAGE_NS } from '../pages/WorkboardPage/i18n';
import { i18n as WorkflowsI18N, WORKFLOWS_PAGE_NS } from '../pages/WorkflowsPage/i18n';
import { i18n as WorkI18N, WORK_PAGE_NS } from '../pages/WorkPage/i18n';
import { i18n as PerformancePageI18N, PERFORMANCE_PAGE_NS } from '../pages/PerformancePage/i18n';
import { ERROR_PAGES_NS, i18n as ErrorPagesI18N } from '../pages/ErrorPages/i18n';
import {
  FLOW_BUILDER2_PAGE_NS,
  i18n as FlowBuilder2PageI18N,
} from '../pages/FlowBuilder2Page/i18n';
import { i18n as RoutesI18N, ROUTES_NS } from './routes';
import { i18n as ThingsGroupPageI18N, THINGS_GROUP_PAGE_NS } from '../pages/ThingsGroupsPage/i18n';
import { i18n as ThingsPageI18N, THINGS_PAGE_NS } from '../pages/ThingsPage/i18n';
import { i18n as ThingPageI18N, THING_PAGE_NS } from '../pages/ThingPage/i18n';
import { i18n as ReportingPageI18n, REPORTING_PAGE_NS } from '../pages/PerformanceReportPage/i18n';
import { i18n as LayoutComponentsI18n, LAYOUT_COMPONENTS_NS } from './layoutComponents';
import {
  i18n as SelectEcosystemI18n,
  SELECT_ECOSYSTEM_PAGE_NS,
} from '../pages/SelectEcosystemPage/i18n';
import { i18n as OnboardingI18n, ONBOARDING_PAGE_NS } from '../pages/OnboardingPage/i18n';
import { HOME_PAGE_NS, i18n as HomePageI18N } from '../pages/HomePage/i18n';
import { CHECKOUT_PAGE_NS, i18n as CheckoutI18n } from '../pages/Checkout/i18n';
import {
  ADP_BARGE_AUDIT_HISTORY_NS,
  i18n as AdpBargeAuditHistoryI18n,
} from '../components/External/AdpBargeAuditHistory/i18n';
import {
  ADP_MASS_FLOW_METER_CHART_NS,
  i18n as AdpMassFlowMeterChartI18n,
} from '../components/External/AdpMassFlowMeter/AdpMassFlowMeterChart/i18n';
import {
  i18n as LupaTimelineI18n,
  LUPA_TIMELINEV3,
} from '../components/External/LupaTimeline/i18n';
import {
  PINNED_DASHBOARDS_NS,
  i18n as PinnedDashboardsI18N,
} from '../components/PinnedDashboards/i18n';
import {
  O3O_VESSEL_SURVEY_MEASUREMENTS,
  i18n as O3oVesselSurveyMeasurementsI18n,
} from '../components/External/O3oVesselSurveyMeasurements/i18n';
import {
  ADP_LAB_RESULTS_NS,
  i18n as AdpLabResultsI18n,
} from '../components/External/AdpLabResults/i18n';
import {
  PERFORMANCE_REPORT_BUILDER_PAGE_NS,
  i18n as PerformanceReportBuilderPageI18n,
} from '../pages/PerformanceReportBuilderPage/i18n';

export const resources = {
  en: {
    [ROUTES_NS]: RoutesI18N.en,

    // components
    [LAYOUT_COMPONENTS_NS]: LayoutComponentsI18n.en,
    [ADP_BARGE_AUDIT_HISTORY_NS]: AdpBargeAuditHistoryI18n.en,
    [ADP_MASS_FLOW_METER_CHART_NS]: AdpMassFlowMeterChartI18n.en,
    [LUPA_TIMELINEV3]: LupaTimelineI18n.en,
    [O3O_VESSEL_SURVEY_MEASUREMENTS]: O3oVesselSurveyMeasurementsI18n.en,

    // pages
    [PERFORMANCE_PAGE_NS]: PerformancePageI18N.en,
    [PERFORMANCE_REPORT_BUILDER_PAGE_NS]: PerformanceReportBuilderPageI18n.en,
    [SILENT_RENEW_PAGE_NS]: SilentRenewI18N.en,
    [WORKBOARD_PAGE_NS]: WorkboardI18N.en,
    [WORKFLOWS_PAGE_NS]: WorkflowsI18N.en,
    [FLOW_BUILDER2_PAGE_NS]: FlowBuilder2PageI18N.en,
    [WORK_PAGE_NS]: WorkI18N.en,
    [THINGS_GROUP_PAGE_NS]: ThingsGroupPageI18N.en,
    [THINGS_PAGE_NS]: ThingsPageI18N.en,
    [THING_PAGE_NS]: ThingPageI18N.en,
    [ERROR_PAGES_NS]: ErrorPagesI18N.en,
    [REPORTING_PAGE_NS]: ReportingPageI18n.en,
    [SELECT_ECOSYSTEM_PAGE_NS]: SelectEcosystemI18n.en,
    [ONBOARDING_PAGE_NS]: OnboardingI18n.en,
    [HOME_PAGE_NS]: HomePageI18N.en,
    [CHECKOUT_PAGE_NS]: CheckoutI18n.en,
    [PINNED_DASHBOARDS_NS]: PinnedDashboardsI18N.en,
    [ADP_LAB_RESULTS_NS]: AdpLabResultsI18n.en,
  },
};
